// extracted by mini-css-extract-plugin
export var fadeIn = "_i1-1";
export var modalContent = "_i1-3";
export var overlay = "_i1-0";
export var popoverContent = "_i1-2";
export var results = "_i1-5";
export var searchInputWrapper = "_i1-4";